import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import SignIn from './pages/SignIn';
import OrderEntry from './pages/OrderEntry';
import OrdersList from './pages/OrdersList';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import Contact from './pages/Contact';
import AboutUs from './pages/AboutUs';
import Products from './pages/Products';
import Prediction from './pages/Prediction';


function App() {
  return (
    <Router>
      <div className="flex flex-col min-h-screen">
        <Header />
        <div className="flex-grow container mx-auto p-4 mt-20">
          {/* <h1 className="text-4xl text-center font-bold mt-8 mb-4 text-gray-800">Welcome to Ninja Baker Restaurant Order System</h1> */}
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/signin" element={<SignIn />} />
            <Route path="/order-entry" element={<OrderEntry />} />
            <Route path="/orders-list" element={<OrdersList />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/products" element={<Products />} />
            <Route path="/prediction" element={<Prediction />} />

          </Routes>
        </div>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
